export const sourceColors = {
  Sendgrid: { bg: "#1a73e8", color: "#ffffff" },
  Apollo: { bg: "#f2f764", color: "#1f2937" },
  Other: { bg: "#6b7280", color: "#ffffff" },
};

export const sourceChip = {
  padding: "4px 12px",
  borderRadius: "4px",
  fontSize: "11px",
  fontWeight: 500,
};

export const typeColors = {
  filter: { bg: "#dbeafe", color: "#1e40af" },
  suppression: { bg: "#fef3c7", color: "#92400e" },
  export: { bg: "#d1fae5", color: "#065f46" },
};

export const typeChip = {
  padding: "4px 12px",
  borderRadius: "4px",
  fontSize: "11px",
  fontWeight: 500,
};

export const defaultTypeColors = {
  bg: "#f3f4f6",
  color: "#374151",
};

export const tableContainer = {
  marginTop: "1rem",
};

export const statusChip = {
  padding: "4px 12px",
  borderRadius: "4px",
  fontSize: "11px",
  fontWeight: 500,
  display: "inline-block",
};

export const statusColors = {
  exported: { bg: "#d1fae5", color: "#065f46" },
  draft: { bg: "#fef3c7", color: "#92400e" },
  active: { bg: "#dbeafe", color: "#1e40af" },
};

export const defaultStatusColors = {
  bg: "#f3f4f6",
  color: "#374151",
};

export const versionCountChip = {
  padding: "4px 12px",
  borderRadius: "4px",
  fontSize: "11px",
  fontWeight: 500,
  display: "inline-block",
  backgroundColor: "#f3f4f6",
  color: "#374151",
};
